// KPIs › DE KPIs at `/c/{slug}/kpis/agents` (DE-KPIS-LIVE): every digital employee's runs, KPIs
// and cost, its helpers (AG) under it, open to whoever may open the scorecard or the chart
// (`CadenceGate`); each DE's row is read under that DE's own record access.
import { createRoute } from "@tanstack/react-router";
import { CadenceGate } from "../features/cadence/cadence-parts";
import { DeKpisScreen } from "../features/kpi/de-kpis-screen";
import { useCompany } from "../features/use-feature";
import { validateFocusSearch } from "../focus/focus";
import { kpisRoute } from "./c.$slug.kpis";

export const deKpisRoute = createRoute({
  getParentRoute: () => kpisRoute,
  path: "agents",
  validateSearch: (search: Record<string, unknown>) => validateFocusSearch(search),
  component: function DeKpis() {
    const { api } = deKpisRoute.useRouteContext();
    return (
      <CadenceGate what="DE KPIs">
        <DeKpisScreen api={api} company={useCompany()} />
      </CadenceGate>
    );
  },
});
